import MNoSubscriptionAnnouncement from '../components/global/MNoSubscriptionAnnouncement'

const CommonAnnouncements = {
    NoSubscription: 'no-subscription'
}

Object.freeze(CommonAnnouncements)

export const announcements = {
    namespaced: true,
    state: {
        announcements: []
    },
    mutations: {
        ADD_ANNOUNCEMENT(state, payload) {
            state.announcements.push(payload)
        },
        SET_ANNOUNCEMENTS(state, payload) {
            state.announcements = payload
        }
    },
    actions: {
        addAnnouncement({ state, commit }, payload) {
            commit('ADD_ANNOUNCEMENT', { id: Date.now(), ...payload })
        },
        removeAnnouncement({ state, commit }, payload) {
            const tmpAnnouncements = state.announcements.filter(e => e.id !== payload)
            commit('SET_ANNOUNCEMENTS', tmpAnnouncements)
        },
        openNoSubscriptionAnnouncement({ state, commit, dispatch }) {
            if(!((state.announcements).find(item => item.key === CommonAnnouncements.NoSubscription))) {
                dispatch('addAnnouncement', {
                    component: MNoSubscriptionAnnouncement,
                    noClosable: true,
                    key: CommonAnnouncements.NoSubscription
                })
            }
        },
        closeNoSubscriptionAnnouncement({ state, commit, dispatch }) {
            const tmpAnnouncements = state.announcements.filter(e => e.key !== CommonAnnouncements.NoSubscription)
            commit('SET_ANNOUNCEMENTS', tmpAnnouncements)
        }

    },
    getters: {
        getAnnouncements(state) {
            return state.announcements
        }
    }
}
